import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('authNSG') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('authNSG')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  async axiosAcceptPDPA (val) {
    const data = val
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}accept_PDPA`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },

  // login
  async axiosLogin (val) {
    const data = val
    // const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}login_web`, data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },

  // login otp
  async GetOTP (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}get_otp_oauth`, val)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ConfirmOTPOneID (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}oauth_otp`, val)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },

  // reset pass
  async SendOTPResetPassword (data) {
    var response
    try {
      response = await axios.post(`${process.env.VUE_APP_BACK_END}sendOTPResetPassword`, data, '')
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ResetPasswordByOTP (data) {
    var response
    try {
      response = await axios.post(`${process.env.VUE_APP_BACK_END}resetPasswordByOTP`, data, '')
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ResetPasswordByEmail (data) {
    var response
    try {
      response = await axios.post(`${process.env.VUE_APP_BACK_END}resetPasswordByEmail`, data, '')
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
